let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4PQhR")).then(() => parcelRequire('eg68j'));